import { useEffect, useMemo, useState } from 'react';

/**
 * A utility hook to check if a media query matches
 *
 * @param mediaQuery
 * @returns {boolean} A boolean value indicating if a media query matches or not
 */
export function useMediaMatch(mediaQuery: string): boolean {
  const matchMedia = useMemo(() => window.matchMedia(mediaQuery), [mediaQuery]);

  const [matches, setMatches] = useState(() => matchMedia.matches);

  useEffect(() => {
    setMatches(matchMedia.matches);

    function onChange(e: MediaQueryListEvent) {
      setMatches(e.matches);
    }

    matchMedia.addEventListener('change', onChange);
    return () => {
      matchMedia.removeEventListener('change', onChange);
    };
  }, [matchMedia]);

  return matches;
}

export function useIsTouchOnlyDevice() {
  return useMediaMatch('(hover: none)');
}
